module.exports = __webpack_public_path__ + "static/x4b-8216dbe9242a1d1ee3894fce86782b50.png";